import React from 'react'
import { isObservable, observe } from 'mobx'
import useSmartviewMounter from '../hooks/use-smartview-mounter'
import { useSelection, useOperation } from '@morningtrain/react-resources'
import { useSmartviewManager } from '../hooks'

export default function MountSmartviewOnSelection (props) {
  const manager = useSmartviewManager()
  const mount = useSmartviewMounter(props.smartview, props.replace, props.keepTreeOnPush)
  const selection = useSelection()
  const operation = useOperation()

  React.useEffect(() => {
    let disposer = null

    if (isObservable(selection.selected)) {
      disposer = observe(selection.selected, change => {
        if (change.type === 'add') {
          if (props.permission !== null) {
            const model = new Map()
            model.set('id', change.newValue)
            if (!operation.can(props.permission, model)) {
              return
            }
          }
          mount({ id: change.newValue })
        } else if (change.type === 'delete') {
          if (props.backOnDeselect) {
            manager.back()
          } else if (props.resetOnDeselect) {
            manager.reset()
          }
        }
      })
    }

    return () => {
      if (typeof disposer === 'function') {
        disposer()
      }
    }
  })

  return null
}

MountSmartviewOnSelection.defaultProps = {
  smartview: null,
  replace: true,
  resetOnDeselect: false,
  backOnDeselect: false,
  keepTreeOnPush: false,
  permission: null
}
